// <pf-badge-estado tono="exito">Activa</pf-badge-estado>
//
// Pastilla visual de estado. Deliberadamente NO conoce vocabulario de
// negocio (no sabe qué significa "suspendida" o "vencido") — el llamador
// decide el `tono` (una de las 5 categorías visuales de abajo) según el
// estado real de la entidad que esté mostrando (empresa, dominio,
// publicación, pago…). Esto evita acoplar el paquete de UI a las tablas del
// dominio, que cambian de fase en fase, y permite reusar el mismo
// componente para CUALQUIER estado futuro sin tocarlo.

const TONOS_VALIDOS = new Set(['exito', 'alerta', 'peligro', 'info', 'neutral', 'premium']);

class BadgeEstado extends HTMLElement {
  static get observedAttributes() {
    return ['tono'];
  }

  connectedCallback() {
    this._render();
  }

  attributeChangedCallback() {
    this._render();
  }

  _render() {
    const tonoSolicitado = this.getAttribute('tono') ?? 'neutral';
    const tono = TONOS_VALIDOS.has(tonoSolicitado) ? tonoSolicitado : 'neutral';

    if (!this.shadowRoot) {
      this.attachShadow({ mode: 'open' });
    }

    this.shadowRoot.innerHTML = `
      <style>
        :host {
          display: inline-flex;
        }
        span {
          display: inline-flex;
          align-items: center;
          gap: 5px;
          font-family: var(--pf-fuente, 'Inter', system-ui, sans-serif);
          font-size: 0.72rem;
          font-weight: 600;
          padding: 3px 10px;
          border-radius: 4px;
          white-space: nowrap;
          line-height: 1.4;
          letter-spacing: 0.01em;
        }
        span::before {
          content: '';
          width: 5px;
          height: 5px;
          border-radius: 50%;
          background: currentColor;
          flex-shrink: 0;
        }
        .exito {
          color: var(--pf-color-exito, #15803d);
          background: var(--pf-color-exito-fondo, #dcfce7);
        }
        .alerta {
          color: var(--pf-color-alerta, #b45309);
          background: var(--pf-color-alerta-fondo, #fef3c7);
        }
        .peligro {
          color: var(--pf-color-peligro, #b91c1c);
          background: var(--pf-color-peligro-fondo, #fee2e2);
        }
        .info {
          color: var(--pf-color-info, #1d4ed8);
          background: var(--pf-color-info-fondo, #dbeafe);
        }
        .neutral {
          color: var(--pf-color-neutral, #374151);
          background: var(--pf-color-neutral-fondo, #f3f4f6);
        }
        .premium {
          color: var(--pf-color-premium, #C9A24D);
          background: var(--pf-color-premium-suave, #FDF8ED);
        }
      </style>
      <span class="${tono}"><slot></slot></span>
    `;
  }
}

customElements.define('pf-badge-estado', BadgeEstado);
